/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import styled from 'styled-components';
import { breakpoints } from '../../../materialui_wrappers/utils/StyledComponentsBreakpoints';

const HeaderActionsWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media print {
    display: none;
  }
  .appheaderactions__searchfield {
    width: 240px;
    height: 36px;

    /* TODO: could be border-top-left-radius, designs will inevitably change */
    &.appheaderactions__searchfield--smallscreen {
      display: none;
      position: absolute;
      left: 6px;
      right: 0;
      width: 100%;
      z-index: 1;
    }
  }

  .appheaderactions__button {
    height: 24px !important;
    padding: 0px !important;
    margin: 0 0 0 20px !important;
  }

  .appheaderactions__button--search {
    display: none;
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .appheaderactions__searchfield--largescreen {
      display: none;
    }
    .appheaderactions__searchfield--smallscreen {
      display: inline-flex !important;
    }

    .appheaderactions__button--search {
      display: inline-flex;
    }
    .appheaderactions__button {
      background-color: transparent !important;
    }
    .appheaderactions__button--user {
      margin-left: 0.25rem !important;
    }
  }
`;

export default HeaderActionsWrapper;
